/* eslint-disable no-restricted-syntax */
// PoC デモ用の最小 UI。文言は日本語（このデモページ限定で no-restricted-syntax を無効化）。
import React from "react";

export const pageContainerStyle: React.CSSProperties = {
  background: "#ffffff",
  color: "#14161b",
  minHeight: "100vh",
  padding: 24,
};

export const contentStyle: React.CSSProperties = {
  maxWidth: 720,
  margin: "0 auto",
};

export const sectionStyle: React.CSSProperties = {
  background: "#ffffff",
  border: "1px solid #e3e6ea",
  borderRadius: 8,
  padding: 16,
  marginBottom: 16,
};

export const PrimaryButton: React.FC<{
  onClick: () => void;
  disabled?: boolean;
  children: React.ReactNode;
}> = ({ onClick, disabled = false, children }) => (
  <button
    type="button"
    onClick={onClick}
    disabled={disabled}
    style={{
      background: disabled ? "#9db2d6" : "#2563eb",
      color: "#ffffff",
      border: "none",
      borderRadius: 8,
      padding: "10px 20px",
      fontSize: 14,
      fontWeight: 700,
      cursor: disabled ? "not-allowed" : "pointer",
    }}
  >
    {children}
  </button>
);

export const Modal: React.FC<{
  open: boolean;
  message: string;
  onClose: () => void;
}> = ({ open, message, onClose }) => {
  if (!open) {
    return null;
  }
  return (
    <div style={overlayStyle}>
      <div style={modalBoxStyle}>
        <p style={{ margin: "0 0 16px", fontSize: 15 }}>{message}</p>
        <PrimaryButton onClick={onClose}>閉じる</PrimaryButton>
      </div>
    </div>
  );
};

const overlayStyle: React.CSSProperties = {
  position: "fixed",
  inset: 0,
  background: "rgba(0, 0, 0, 0.4)",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  zIndex: 1000,
};

const modalBoxStyle: React.CSSProperties = {
  background: "#ffffff",
  color: "#14161b",
  borderRadius: 12,
  padding: 24,
  maxWidth: 360,
  width: "90%",
  boxShadow: "0 10px 40px rgba(0, 0, 0, 0.2)",
  textAlign: "center",
};
